import React from 'react';
import moment from 'moment';

import Button from '@mui/lab/LoadingButton';
import CircularProgress from '@mui/material/CircularProgress';

import { useQuery, useMutation, useQueryClient } from 'react-query';
import { useParams } from 'react-router-dom';

import { getAccountBalanceTransferDetail, confirmAccountBalanceTransfer } from 'api/accountbalancetransfers';

const AccountBalanceTransfer: React.FC = () => {
    const queryClient = useQueryClient();
    const { transferId } = useParams();

    const detailQuery = useQuery(['accountbalancetransfer', transferId], getAccountBalanceTransferDetail, {
        enabled: !!transferId,
    });

    const confirmMutation = useMutation(() => confirmAccountBalanceTransfer(transferId!), {
        onSuccess: () => {
            queryClient.invalidateQueries(['accountbalancetransfer', transferId]);
        }
    });

    return (
        <div className="col-span-12">
            <div className="w-full h-full bg-white shadow-md p-5 rounded" style={{ minHeight: 500 }}>
                {detailQuery.isLoading ? (
                    <div className="flex items-center justify-center h-full" style={{ minHeight: 500 }}>
                        <CircularProgress />
                    </div>
                ) : (<>
                <p className="text-lg font-medium mb-8">Перевод (румы) №{transferId}</p>

                <p className="text-lg font-light mb-4">
                    Дата создания: {moment(detailQuery.data?.created_datetime).format('DD MMM YYYY HH:mm')}
                </p>
                <p className="text-lg font-light mb-4">
                    Игрок: {detailQuery.data?.player_username}
                </p>
                <div className="bg-gray-50 border border-gray-200 rounded py-2 mb-4 inline-block" style={{ marginLeft: '-0.75rem', paddingLeft: '0.75rem', paddingRight: '0.75rem' }}>
                    <p className="text-lg font-light mb-1">
                        Из рума: <span className="font-medium">{detailQuery.data?.cashout_room_name}</span> ({detailQuery.data?.cashout_room_balance} {detailQuery.data?.chip_currency_name})
                    </p>
                    <p className="text-lg font-light mb-1">
                        В рум: <span className="font-medium">{detailQuery.data?.deposit_room_name}</span> ({detailQuery.data?.deposit_room_balance} {detailQuery.data?.chip_currency_name})
                    </p>
                    <p className="text-lg font-light">
                        Сумма: <span className="font-medium">{detailQuery.data?.amount} {detailQuery.data?.chip_currency_name}</span>
                    </p>
                </div>
                <p className="text-lg font-light mb-4">
                    Кэшаут:{' '}
                    {/(https?:\/\/[^\s]+)/.test(detailQuery.data?.comment || '') ? (
                        <a href={detailQuery.data.comment.match(/(https?:\/\/[^\s]+)/)[0]} target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">
                            {detailQuery.data?.comment}
                        </a>
                    ) : detailQuery.data?.comment}
                </p>

                {detailQuery.data?.cashout_screenshot && (
                    <p className="text-lg font-light mb-4">
                        Скриншот кэшаута:{' '}
                        <a href={detailQuery.data.cashout_screenshot} target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">
                            открыть
                        </a>
                    </p>
                )}

                <p className="text-lg font-light mb-4">
                    Депозит:{' '}
                    {/(https?:\/\/[^\s]+)/.test(detailQuery.data?.deposit_scr || '') ? (
                        <a href={detailQuery.data.deposit_scr.match(/(https?:\/\/[^\s]+)/)[0]} target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">
                            {detailQuery.data?.deposit_scr}
                        </a>
                    ) : detailQuery.data?.deposit_scr}
                </p>

                {detailQuery.data && (
                    <p className="text-lg font-light mb-4">
                        Статус: <span className={`px-2 rounded ${detailQuery.data.is_processed ? 'bg-green-200' : 'bg-amber-500'}`} style={{ paddingTop: '1.2px', paddingBottom: '1.2px' }}>{detailQuery.data.is_processed ? 'processed' : 'pending'}</span>
                    </p>
                )}
                {detailQuery.data?.processed_datetime && (
                    <p className="text-lg font-light mb-4">
                        Дата обработки: {moment(detailQuery.data?.processed_datetime).format('DD MMM YYYY HH:mm')}
                    </p>
                )}

                {!detailQuery.data?.is_processed && (
                    <div className="pt-4">
                        <Button
                            variant="contained"
                            color="success"
                            loading={confirmMutation.isLoading}
                            onClick={() => confirmMutation.mutate()}
                        >
                            Подтвердить
                        </Button>
                    </div>
                )}
                </>)}
            </div>
        </div>
    );
};

export default AccountBalanceTransfer;
